<div class="modal-content">
    <div class="modal-header">
        <h1 class="modal-title fs-5" id="xxlModalLabel">{{title}}</h1>
        <button class="btn-close py-0" type="button" (click)="modalServices.dismissAll()"></button>
    </div>
    <div class="modal-body dark-modal">
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="form theme-form">
                                <div class="row">
                                    <div *ngFor="let field of formFields" class="col-sm-6 mb-3" [ngClass]="{'d-none': (field.hide || (!isNew && field.type == 'password'))}">
                                        <label [for]="field.id">{{ field.title }} {{(field.required) ? '*' : '' }}</label>
                                        <ng-container [ngSwitch]="field.type">
                                            <!-- Input Fields -->
                                            <input
                                                    *ngSwitchCase="'text'"
                                                    class="form-control"
                                                    [id]="field.id"
                                                    [type]="field.type"
                                                    [placeholder]="field.placeholder"
                                                    [readonly]="(field.defaultValue)"
                                                    [required]="field.required"
                                                    [(ngModel)]="formData[field.id]"
                                            />
                                            <div class="input-group" *ngSwitchCase="'password'">
                                                <input
                                                        class="form-control"
                                                        [id]="field.id"
                                                        [type]="field.showPassword ? 'text' : 'password'"
                                                        [placeholder]="field.placeholder"
                                                        [required]="field.required"
                                                        [(ngModel)]="formData[field.id]"
                                                />
                                                <button
                                                        type="button"
                                                        class="btn btn-outline-primary"
                                                        (click)="togglePasswordVisibility(field)"
                                                >
                                                    <i class="fa" [ngClass]="field.showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                                                </button>
                                            </div>
                                            <input
                                                    *ngSwitchCase="'number'"
                                                    class="form-control"
                                                    [id]="field.id"
                                                    [type]="field.type"
                                                    [placeholder]="field.placeholder"
                                                    [required]="field.required"
                                                    [(ngModel)]="formData[field.id]"
                                            />
                                            <div class="col-12 input-group" *ngSwitchCase="'currency'"><span class="input-group-text">$</span>
                                                <input
                                                        class="form-control"
                                                        [id]="field.id"
                                                        [type]="field.type"
                                                        [placeholder]="field.placeholder"
                                                        [required]="field.required"
                                                        [(ngModel)]="formData[field.id]"
                                                />
                                            </div>

                                            <input
                                                    *ngSwitchCase="'email'"
                                                    class="form-control"
                                                    [id]="field.id"
                                                    [type]="field.type"
                                                    [placeholder]="field.placeholder"
                                                    [required]="field.required"
                                                    [(ngModel)]="formData[field.id]"
                                            />
                                            <input
                                                    *ngSwitchCase="'date'"
                                                    class="form-control"
                                                    [id]="field.id"
                                                    [type]="field.type"
                                                    [required]="field.required"
                                                    [(ngModel)]="formData[field.id]"
                                            />

                                            <select
                                                    *ngSwitchCase="'select'"
                                                    class="form-select"
                                                    [id]="field.id"
                                                    [required]="field.required"
                                                    [(ngModel)]="formData[field.id]"
                                            >
                                                <option value="" *ngIf="!field.required">
                                                    {{ field.placeholder || 'Seleccione...' }}
                                                </option>
                                                <option *ngFor="let option of selectOptions[field.id]" [value]="option.id">
                                                    {{ option.value }}
                                                </option>
                                            </select>

                                            <div *ngSwitchCase="'boolean'" class="col-12">
                                                <div class="form-check form-switch">
                                                    <input
                                                            class="form-check-input"
                                                            [id]="field.id"
                                                            type="checkbox"
                                                            role="switch"
                                                            [(ngModel)]="formData[field.id]"
                                                            [ngModelOptions]="{standalone: true}"
                                                            (change)="onBooleanChange($event, field.id)"
                                                    [required]="field.required"
                                                    />
                                                    <label class="form-check-label" [for]="field.id">{{ field.placeholder }}</label>
                                                </div>
                                            </div>

                                            <!-- Image Field -->
                                            <div *ngSwitchCase="'images'">
                                                <input
                                                        type="file"
                                                        class="form-control"
                                                        [id]="field.id"
                                                        [required]="field.required"
                                                        (change)="onImageSelected($event, field.id)"
                                                />
                                                <!-- Previsualización de la imagen -->
                                                <div *ngIf="formData[field.id]" class="mt-3 text-center">
                                                    <img [src]="formData[field.id]" alt="Selected image" style="max-width: 100px; max-height: 100px; object-fit: cover;">
                                                </div>
                                            </div>

                                            <!-- Textarea Field -->
                                            <textarea
                                                    *ngSwitchCase="'textarea'"
                                                    class="form-control"
                                                    [id]="field.id"
                                                    [placeholder]="field.placeholder"
                                                    [rows]="3"
                                                    [required]="field.required"
                                                    [(ngModel)]="formData[field.id]"
                                            ></textarea>
                                        </ng-container>
                                        <div class="invalid-feedback">
                                            Este campo es obligatorio o inválido.
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" type="button" (click)="modalServices.dismissAll()">Cerrar</button>
        <button class="btn btn-primary" type="button" (click)="save()">Guardar</button>
    </div>
</div>
